/**
 * Аватарки (PFP) пользователя — статичные картинки из shared/img/avatars/.
 *
 * Импортируем их явно, чтобы webpack положил файлы в бандл и отдал
 * корректные URL.  Выбор аватарки хранится индексом в localStorage
 * (см. useAvatar); «рандомизация» = случайный индекс из этого списка.
 */
import avatar1 from 'shared/img/avatars/RC_LOGO_1.png'
import avatar2 from 'shared/img/avatars/RC_LOGO_2.png'
import avatar3 from 'shared/img/avatars/RC_LOGO_3.png'

/** Все доступные аватарки (порядок = индекс в localStorage). */
export const AVATARS: string[] = [avatar1, avatar2, avatar3]

/** FNV-1a 32-bit hash — стабильный дефолтный выбор по id аккаунта. */
const hash = (str: string): number => {
    let h = 0x811c9dc5
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i)
        h = Math.imul(h, 0x01000193)
    }
    return h >>> 0
}

/** URL аватарки по индексу (с защитой от выхода за границы). */
export const avatarByIndex = (index: number): string =>
    AVATARS[((index % AVATARS.length) + AVATARS.length) % AVATARS.length]

/** Детерминированный индекс по id — стабильная аватарка «по умолчанию». */
export const defaultAvatarIndex = (id?: number | string): number =>
    hash(String(id ?? 'guest')) % AVATARS.length

/** Случайный индекс, отличный от текущего (если их больше одной). */
export const randomAvatarIndex = (current: number): number => {
    if (AVATARS.length <= 1) return 0
    let next = current
    while (next === current) {
        next = Math.floor(Math.random() * AVATARS.length)
    }
    return next
}
